import styled from 'styled-components';

export const FloatButtonSpacePlaceholder = styled.div`
  padding: 48px;
`;
